export const sixtysecreport = [
  { show: true, value: "Unlimited Cellular Data" },
  { show: true, value: "Cloud Software" },
  { show: true, value: "Mobile Application" },
  { show: true, value: "60-Second Location Updates" },
  { show: true, value: "Single Login" },
  { show: true, value: "3 Monthd of Tracking History" },
  { show: true, value: "5 Geofences" },
  { show: true, value: "60 SMS Alerts" },
  { show: true, value: "2 Standard Reports" },
  { show: false, value: "Future Device Discounts" },
  { show: false, value: "Shareable Live Map Links" },
  { show: false, value: "Unlimited Custom Reports" },
  { show: false, value: "Device Insurance Included" },
  { show: false, value: "Dispatch & Routing" },
  { show: false, value: "Driver Compliance" },
  { show: false, value: "Workflow Manager" },
  { show: false, value: "API Access" },
];
export const thirtysecreport = [
  { show: true, value: "Coverage in North America" },
  { show: true, value: "6 Months Tracking History" },
  { show: true, value: "10 Geofences" },
  { show: true, value: "60 Coordinate Change SMS Alerts" },
  { show: true, value: "60 G-Sensor SMS Alerts" },
  { show: true, value: "8 Standard Reports" },
  { show: false, value: "SOS" },
  { show: false, value: "Shareable Live Map Links" },
  { show: false, value: "GPX Routing" },
];
export const fifteensecreport = [
  { show: true, value: "Unlimited Cellular Data" },
  { show: true, value: "Cloud Software" },
  { show: true, value: "Mobile Application" },
  { show: true, value: "60-Second Location Updates" },
  { show: true, value: "Single Login" },
  { show: true, value: "3 Monthd of Tracking History" },
  { show: true, value: "5 Geofences" },
  { show: true, value: "60 SMS Alerts" },
  { show: true, value: "2 Standard Reports" },
  { show: true, value: "Future Device Discounts" },
  { show: true, value: "Shareable Live Map Links" },
  { show: true, value: "Unlimited Custom Reports" },
  { show: true, value: "Device Insurance Included" },
  { show: false, value: "Dispatch & Routing" },
  { show: false, value: "Driver Compliance" },
  { show: false, value: "Workflow Manager" },
  { show: false, value: "API Access" },
];
export const fivesecreport = [
  { show: true, value: "Coverage in North America & Europe" },
  { show: true, value: "12 Months Tracking History" },
  { show: true, value: "100 Geofences" },
  { show: true, value: "400 Coordinate Change SMS Alerts" },
  { show: true, value: "200 G-Sensor SMS Alerts" },
  { show: true, value: "8 Standard Reports" },
  { show: true, value: "SOS" },
  { show: true, value: "Shareable Live Map Links" },
  { show: true, value: "GPX Routing" },
];
export const onesecreport = [
  { show: true, value: "Worldwide Coverage" },
  { show: true, value: "24 Months Tracking History" },
  { show: true, value: "Unlimited Geofences" },
  { show: true, value: "Unlimited Coordinate Change SMS Alerts" },
  { show: true, value: "Unlimited G-Sensor SMS Alerts" },
  { show: true, value: "8 Standard Reports" },
  { show: true, value: "SOS" },
  { show: true, value: "Shareable Live Map Links" },
  { show: true, value: "GPX Routing" },
];
// export const sixtysecreport = [
//   { show: true, value: "Unlimited Cellular Data" },
//   { show: true, value: "Cloud Software" },
//   { show: true, value: "Mobile Application" },
//   { show: true, value: "60-Second Location Updates" },
//   { show: true, value: "Single Login" },
//   { show: true, value: "3 Monthd of Tracking History" },
//   { show: true, value: "5 Geofences" },
//   { show: true, value: "60 SMS Alerts" },
//   { show: true, value: "2 Standard Reports" },
//   { show: false, value: "Future Device Discounts" },
//   { show: false, value: "Shareable Live Map Links" },
//   { show: false, value: "Unlimited Custom Reports" },
//   { show: false, value: "Device Insurance Included" },
//   { show: false, value: "Dispatch & Routing" },
//   { show: false, value: "Driver Compliance" },
//   { show: false, value: "Workflow Manager" },
//   { show: false, value: "API Access" },
// ];
// export const thirtysecreport = [
//   { show: true, value: "Unlimited Cellular Data" },
//   { show: true, value: "Cloud Software" },
//   { show: true, value: "Mobile Application" },
//   { show: true, value: "60-Second Location Updates" },
//   { show: true, value: "Single Login" },
//   { show: true, value: "3 Monthd of Tracking History" },
//   { show: true, value: "5 Geofences" },
//   { show: true, value: "60 SMS Alerts" },
//   { show: true, value: "2 Standard Reports" },
//   { show: true, value: "Future Device Discounts" },
//   { show: true, value: "Shareable Live Map Links" },
//   { show: false, value: "Unlimited Custom Reports" },
//   { show: false, value: "Device Insurance Included" },
//   { show: false, value: "Dispatch & Routing" },
//   { show: false, value: "Driver Compliance" },
//   { show: false, value: "Workflow Manager" },
//   { show: false, value: "API Access" },
// ];
// export const fifteensecreport = [
//   { show: true, value: "Unlimited Cellular Data" },
//   { show: true, value: "Cloud Software" },
//   { show: true, value: "Mobile Application" },
//   { show: true, value: "60-Second Location Updates" },
//   { show: true, value: "Single Login" },
//   { show: true, value: "3 Monthd of Tracking History" },
//   { show: true, value: "5 Geofences" },
//   { show: true, value: "60 SMS Alerts" },
//   { show: true, value: "2 Standard Reports" },
//   { show: true, value: "Future Device Discounts" },
//   { show: true, value: "Shareable Live Map Links" },
//   { show: true, value: "Unlimited Custom Reports" },
//   { show: true, value: "Device Insurance Included" },
//   { show: false, value: "Dispatch & Routing" },
//   { show: false, value: "Driver Compliance" },
//   { show: false, value: "Workflow Manager" },
//   { show: false, value: "API Access" },
// ];
// export const fivesecreport = [
//   { show: true, value: "Unlimited Cellular Data" },
//   { show: true, value: "Cloud Software" },
//   { show: true, value: "Mobile Application" },
//   { show: true, value: "60-Second Location Updates" },
//   { show: true, value: "Single Login" },
//   { show: true, value: "3 Monthd of Tracking History" },
//   { show: true, value: "5 Geofences" },
//   { show: true, value: "60 SMS Alerts" },
//   { show: true, value: "2 Standard Reports" },
//   { show: true, value: "Future Device Discounts" },
//   { show: true, value: "Shareable Live Map Links" },
//   { show: true, value: "Unlimited Custom Reports" },
//   { show: true, value: "Device Insurance Included" },
//   { show: true, value: "Dispatch & Routing" },
//   { show: true, value: "Driver Compliance" },
//   { show: false, value: "Workflow Manager" },
//   { show: false, value: "API Access" },
// ];
// export const onesecreport = [
//   { show: true, value: "Unlimited Cellular Data" },
//   { show: true, value: "Cloud Software" },
//   { show: true, value: "Mobile Application" },
//   { show: true, value: "60-Second Location Updates" },
//   { show: true, value: "Single Login" },
//   { show: true, value: "3 Monthd of Tracking History" },
//   { show: true, value: "5 Geofences" },
//   { show: true, value: "60 SMS Alerts" },
//   { show: true, value: "2 Standard Reports" },
//   { show: true, value: "Future Device Discounts" },
//   { show: true, value: "Shareable Live Map Links" },
//   { show: true, value: "Unlimited Custom Reports" },
//   { show: true, value: "Device Insurance Included" },
//   { show: true, value: "Dispatch & Routing" },
//   { show: true, value: "Driver Compliance" },
//   { show: true, value: "Workflow Manager" },
//   { show: true, value: "API Access" },
// ];

export const pointtochk = [
  { key: "coverage", value: "Works in USA,Canada and Mexico" },
  { key: "data_retaintion_month_", value: ": Months Tracking History" },
  { key: "geofence_", value: ": Geofences" },
  { key: "customer_report_", value: ": Standard Reports" },
  { key: "sms_alerts_", value: ": SMS Alerts" },
  // { key: "coordinate_sms_alerts_", value: ": Coordinate Change SMS Alerts" },
  { key: "gsensor_enable", value: "G-Sensor SMS Alerts" },
  { key: "sos_button", value: "SOS" },
  { key: "shareable_live_map", value: "Shareable Live Map Links" },
  { key: "gpx_routing", value: "GPX Routing" },
  { key: "allow_second_phone_number", value: "Secondary Phone Number" },
  { key: "telemetry_data", value: "Telemetry Data" },
  { key: "delete_trips", value: "Delete Trips" },
  { key: "delete_reports", value: "Delete Reports" },
];
export const pointtochkobj = {
  coverage: { value: "Works in USA,Canada and Mexico" },
  data_retaintion_month_: { value: ": Months Tracking History" },
  geofence_: { value: ": Geofences" },
  customer_report_: { value: ": Standard Reports" },
  sms_alerts_: { value: ": SMS Alerts" },
  // coordinate_sms_alerts_: { value: ": Coordinate Change SMS Alerts" },
  gsensor_enable: { value: "G-Sensor SMS Alerts" },
  sos_button: { value: "SOS" },
  shareable_live_map: { value: "Shareable Live Map Links" },
  gpx_routing: { value: "GPX Routing" },
  allow_second_phone_number: { value: "Secondary Phone Number" },
  telemetry_data: { value: "Telemetry Data" },
  delete_trips: { value: "Delete Trips" },
  delete_reports: { value: "Delete Reports" },
};
export const pointtochkobd = [
  { key: "coverage", value: "Works in USA,Canada and Mexico" },
  { key: "data_retaintion_month_", value: ": Months Tracking History" },
  { key: "customer_report_", value: ": Standard Reports" },
  { key: "sms_alerts_", value: ": SMS Alerts" },
  { key: "towing_alert", value: "Towing Alerts" },
  { key: "harsh_behaviour", value: "Harsh Behaviour Alerts" },
  { key: "crash_detection", value: "Crash Detection Alerts" },
  { key: "driver_score", value: "Driver Score Reports" },
  { key: "shareable_live_map", value: "Shareable Live Map Links" },
  { key: "gpx_routing", value: "GPX Routing" },
  { key: "allow_second_phone_number", value: "Secondary Phone Number" },
  { key: "telemetry_data", value: "Telemetry Data" },
  { key: "delete_trips", value: "Delete Trips" },
  { key: "delete_reports", value: "Delete Reports" },
];
export const pointtochkobjobd = {
  coverage: { value: "Works in USA,Canada and Mexico" },
  data_retaintion_month_: { value: ": Months Tracking History" },
  customer_report_: { value: ": Standard Reports" },
  sms_alerts_: { value: ": SMS Alerts" },
  harsh_behaviour: { value: "Harsh Behaviour Alerts" },
  crash_detection: { value: "Crash Detection Alerts" },
  towing_alert: { value: "Towing Alerts" },
  driver_score: { value: "Driver Score Reports" },
  shareable_live_map: { value: "Shareable Live Map Links" },
  gpx_routing: { value: "GPX Routing" },
  allow_second_phone_number: { value: "Secondary Phone Number" },
  telemetry_data: { value: "Telemetry Data" },
  delete_trips: { value: "Delete Trips" },
  delete_reports: { value: "Delete Reports" },
};
